// Vanilla widget-dom renderer (WIDGET track): the "one UI" over the
// renderer-agnostic seam. Depends only on ./sdk + ./core — zero React.
export {
  createDealerWidget,
  createWidgetRenderer,
  type DealerWidgetMode,
  type DealerWidgetOptions,
  type WidgetRendererOptions,
  type WidgetHandle,
} from './dealer-widget.js';
export { ensureWidgetStyles } from './styles.js';
export {
  createBarVisualizer,
  type BarVisualizerHandle,
  type BarVisualizerOptions,
  type VisualizerState,
  type AnalyserProvider,
} from './visualizer.js';

// Seam re-exports so a widget consumer can type a custom StateSource without
// also importing ./sdk.
export type {
  StateSource,
  WidgetState,
  WidgetActions,
  WidgetAgentState,
} from '../core/logic/widget-state.js';
